module.exports = __webpack_public_path__ + "img/analytics-graph.ffb340b6.svg";